
export const messages = {
  'messages.saved': 'Votre demande a été enregistrée en tant que brouillon.',
  'messages.documentUploaded': 'Document téléchargé',
  'messages.documentUploadedDesc': 'a été téléchargé avec succès.',
  'messages.documentRemoved': 'Document supprimé',
  'messages.documentRemovedDesc': 'Le document a été supprimé du coffre-fort',
  'messages.formGenerated': 'Formulaire généré',
  'messages.formGeneratedDesc': 'a été généré et rempli avec les données de votre ferme.',
  'messages.documentDownloaded': 'Document téléchargé',
  'messages.documentDownloadedDesc': 'a été téléchargé sur votre appareil.',
  'messages.scanningDocument': 'Analyse du document avec OCR...',
  'messages.fieldsDetected': 'champs détectés',
  'messages.fillingIn': 'Remplissage',
  'messages.formSaved': 'Formulaire enregistré dans votre profil. Vous pouvez maintenant visiter le Portail UE.',
  'messages.uploading': 'Téléchargement',
  'messages.complete': 'Terminé',
  'messages.formAutofilled': 'Formulaire rempli automatiquement',
  'messages.formAutofilledDesc': 'Les données de votre profil de ferme ont été utilisées pour remplir le formulaire.',
  'messages.pdfFormAdded': 'Formulaire PDF ajouté',
  'messages.pdfFormAddedDesc': 'Votre Formulaire de Déclaration d\'Irrigation complété a été téléchargé.',
  'messages.docUploadedFromVault': 'Document téléchargé depuis le coffre-fort',
  'messages.docUploadedFromVaultDesc': 'a été téléchargé depuis votre coffre-fort de documents.',
  'messages.appSubmitted': 'Demande soumise',
  'messages.appSubmittedDesc': 'Votre demande a été soumise avec succès.',
  'messages.detectedFields': 'Champs détectés',
  'messages.autoFilled': 'Remplis automatiquement',
  'messages.remaining': 'restants',
  'messages.subsidyAttached': 'Subvention attachée à la ferme',
  'messages.subsidyAttachedDesc': 'La subvention a été ajoutée au profil de votre ferme',
  'messages.simulationComplete': 'Simulation terminée',
  'messages.simulationCompleteDesc': 'Votre simulation a été complétée avec succès.',
  'messages.simulationSaved': 'Simulation sauvegardée',
  'messages.simulationSavedDesc': 'Votre simulation a été sauvegardée.',
  'messages.documentAnalyzed': 'Document analysé',
  'messages.documentAnalyzedDesc': 'Le document a été analysé pour des subventions potentielles.',
  'messages.chatAnalysisComplete': 'Analyse du chat terminée',
  'messages.chatAnalysisCompleteDesc': 'Des correspondances de subventions potentielles ont été trouvées basées sur votre description.',

  // Toast messages - Success
  'messages.success.saved': 'Enregistré avec succès',
  'messages.success.deleted': 'Supprimé avec succès',
  'messages.success.created': 'Créé avec succès',
  'messages.success.updated': 'Mis à jour avec succès',
  'messages.success.uploaded': 'Téléchargé avec succès',
  'messages.success.sent': 'Envoyé avec succès',
  'messages.success.copied': 'Copié avec succès',
  'messages.success.refreshed': 'Actualisé avec succès',
  'messages.success.categorySaved': 'Catégorie enregistrée avec succès',
  'messages.success.categoryDeleted': 'Catégorie "{name}" supprimée',
  'messages.success.invitationSent': 'Invitation envoyée',
  'messages.success.profileCreated': 'Profil créé avec succès',
  'messages.success.searchRefreshed': 'Recherche actualisée',
  'messages.success.extractionCompleted': 'Extraction structurelle terminée avec succès',
  'messages.success.documentReprocessed': 'Document retraité avec le modèle premium',
  'messages.success.preferencesUpdated': 'Préférences email mises à jour',
  'messages.success.unsubscribed': 'Désabonné de toutes les notifications email',
  'messages.success.resubscribed': 'Réabonné aux notifications email',
  'messages.success.lockReleased': 'Verrou libéré avec succès',
  'messages.success.diagnosticsCompleted': 'Diagnostics terminés',
  'messages.success.pipelineCompleted': 'Pipeline de débogage terminé !',
  'messages.success.jobCancelled': 'Tâche annulée avec succès',
  'messages.success.jobScheduledRetry': 'Tâche programmée pour nouvelle tentative',
  'messages.success.syncCompleted': 'Synchronisation douce terminée !',
  'messages.success.apiSyncCompleted': 'Synchronisation de {apiSource} réussie',
  'messages.success.apiSyncDetails': 'Trouvés : {found}, Ajoutés : {inserted}, Ignorés : {skipped}',
  'messages.success.subsidiesCollected': '{count} nouvelles subventions collectées avec succès !',
  'messages.success.cacheDataRetrieved': 'Données enrichies récupérées du cache',
  'messages.success.extractionLogDownloaded': 'Journal d\'extraction téléchargé',
  'messages.success.aiExtractionCompleted': 'Extraction IA terminée avec succès',
  'messages.success.farmUpdated': 'Profil de ferme mis à jour avec succès',

  // Toast messages - Error
  'messages.error.failed': 'Opération échouée',
  'messages.error.loadFailed': 'Échec du chargement',
  'messages.error.saveFailed': 'Échec de la sauvegarde',
  'messages.error.deleteFailed': 'Échec de la suppression',
  'messages.error.uploadFailed': 'Échec du téléchargement',
  'messages.error.categorySaveFailed': 'Échec de la sauvegarde de la catégorie',
  'messages.error.cannotDeleteDefaultCategory': 'Les catégories par défaut ne peuvent pas être supprimées',
  'messages.error.invalidEmail': 'Veuillez entrer une adresse email valide',
  'messages.error.invitationFailed': 'Échec de l\'invitation',
  'messages.error.extractionHistoryFailed': 'Échec du chargement de l\'historique d\'extraction',
  'messages.error.aiExtractionFailed': 'Échec de l\'extraction IA',
  'messages.error.userRolesFetchFailed': 'Échec de la récupération des utilisateurs et rôles',
  'messages.error.syncJobFetchFailed': 'Échec de la récupération du statut de la tâche de synchronisation',
  'messages.error.apiSyncFailed': 'Échec de la synchronisation de {apiSource}',
  'messages.error.fullRefreshFailed': 'Échec du rafraîchissement complet',
  'messages.error.collectionFailed': 'Échec de la collecte : {message}',
  'messages.error.lockReleaseFailed': 'Échec de la libération du verrou',
  'messages.error.diagnosticsFailed': 'Échec des diagnostics',
  'messages.error.systemError': 'Erreur système pendant l\'extraction',
  'messages.error.pipelineResultsFailed': 'Échec du chargement des résultats du pipeline',
  'messages.error.retryBetterModelFailed': 'Échec de la nouvelle tentative avec un meilleur modèle',
  'messages.error.emailPreferencesFailed': 'Échec du chargement des préférences email',
  'messages.error.updatePreferenceFailed': 'Échec de la mise à jour de la préférence email',
  'messages.error.unsubscribeFailed': 'Échec du désabonnement des emails',
  'messages.error.resubscribeFailed': 'Échec du réabonnement aux emails',
  'messages.error.reprocessFailed': 'Échec du retraitement des documents',
  'messages.error.jobQueueFailed': 'Échec du chargement des données de la file d\'attente des tâches',
  'messages.error.processJobsFailed': 'Échec du traitement des tâches',
  'messages.error.enqueueJobFailed': 'Échec de la mise en file d\'attente de la tâche',
  'messages.error.cancelJobFailed': 'Échec de l\'annulation de la tâche',
  'messages.error.retryJobFailed': 'Échec de la nouvelle tentative de la tâche',
  'messages.error.loadFeedbackFailed': 'Impossible de charger les préférences',
  'messages.error.saveFeedbackFailed': 'Erreur lors de l\'enregistrement',
  'messages.error.authenticationRequired': 'Vous devez être connecté pour cette action',
  'messages.error.noProfileSelected': 'Aucun profil sélectionné',
  'messages.error.invalidSubsidy': 'Subvention invalide',
  'messages.error.cannotSaveAction': 'Impossible d\'enregistrer cette action',
  'messages.error.profileNotFound': 'Profil non trouvé',
  'messages.error.profileNotFoundDesc': 'Le profil sélectionné n\'existe plus. Veuillez rafraîchir la page.',
  'messages.error.sessionExpired': 'Session expirée',
  'messages.error.sessionExpiredDesc': 'Veuillez vous reconnecter',
  'messages.error.databaseError': 'Erreur de base de données',
  'messages.error.databaseErrorDesc': 'Impossible de sauvegarder votre choix',
  'messages.error.hidingError': 'Erreur lors du masquage',
  'messages.error.hidingErrorDesc': 'Veuillez réessayer plus tard',
  'messages.error.deleteFeedbackFailed': 'Erreur lors de la suppression',
  'messages.error.loadSubsidiesFailed': 'Échec du chargement des subventions',
  'messages.error.loadMoreSubsidiesFailed': 'Échec du chargement de plus de subventions',
  'messages.error.loadTrackedFailed': 'Erreur lors du chargement',
  'messages.error.addError': 'Erreur lors de l\'ajout',
  'messages.error.addErrorDesc': 'Veuillez réessayer',
  'messages.error.selectAtLeastOneSubsidy': 'Veuillez sélectionner au moins une subvention',
  'messages.error.invalidCompanyInfo': 'Informations entreprise invalides',
  'messages.error.pdfExportFailed': 'Erreur lors de l\'export PDF',
  'messages.error.applyExtractionFailed': 'Échec de l\'application de l\'extraction',
  'messages.error.updateFailed': 'Échec de la mise à jour du profil de ferme',
  'messages.error.reprocessDocumentsFailed': 'Échec du retraitement des documents',
  'messages.error.signInRequired': 'Veuillez vous connecter pour mettre en favoris',
  'messages.error.updateStarredFailed': 'Échec de la mise à jour des favoris',
  'messages.error.updateNotesFailed': 'Échec de la mise à jour des notes',
  'messages.error.updateReminderFailed': 'Échec de la mise à jour des paramètres de rappel',
  'messages.error.queueFailed': 'Échec du démarrage du traitement',
  'messages.error.processingCompleteFailed': 'Traitement terminé !',
  'messages.error.processingFailedWithMessage': 'Échec du traitement : {message}',
  'messages.error.triggerProcessorFailed': 'Traitement démarré mais pourrait prendre plus de temps que prévu',
  'messages.error.premiumRetryFailed': 'Échec de la nouvelle tentative avec un meilleur modèle',
  'messages.error.extractionFailedFallback': 'Échec de l\'extraction locale',
  'messages.error.extractionFailedFallbackDesc': 'Basculement vers l\'extraction cloud',
  'messages.error.localExtractionFailed': 'Échec de l\'extraction locale',
  'messages.error.localExtractionFailedDesc': 'Tentative d\'extraction cloud à la place',
  'messages.error.uploadIncomplete': 'Téléchargement incomplet',
  'messages.error.uploadIncompleteDesc': 'Tentative d\'extraction non enregistrée. Veuillez réessayer une fois le téléchargement terminé.',
  'messages.error.extractionHistoryLoadFailed': 'Échec du chargement de l\'historique d\'extraction',
  'messages.error.aiExtractionStartFailed': 'Extraction IA démarrée pour {fileName}',
  'messages.error.aiExtractionCompleteSuccess': 'Extraction IA terminée avec succès',
  'messages.error.aiExtractionCompleteSuccessDesc': '{confidence}% de confiance, {fieldCount} champs extraits',
  'messages.error.aiExtractionCompleteFailed': 'Échec de l\'extraction IA',
  'messages.error.aiExtractionCompleteFailedDesc': 'Erreur inconnue',
  'messages.error.enrichedDataRetrieved': 'Données enrichies récupérées du cache',
  'messages.error.localAnalysisComplete': 'Analyse locale terminée ({confidence}% confiance)',
  'messages.error.hybridAnalysisComplete': 'Analyse hybride terminée ({confidence}% confiance)',
  'messages.error.aiAnalysisComplete': 'Analyse IA terminée ({confidence}% confiance)',
  'messages.error.lowConfidenceAnalysis': 'Analyse locale avec confiance limitée ({confidence}%)',
  'messages.error.noExtractionMethodSucceeded': 'Aucune méthode d\'extraction n\'a réussi',
  'messages.error.analysisError': 'Erreur d\'analyse : {message}',
  'messages.error.securityViolation': 'Violation de sécurité : {error}',
  'messages.error.validationError': 'Erreur de validation : {error}',
  'messages.error.rateLimitExceeded': 'Limite de taux dépassée. Veuillez patienter avant de réessayer.',
  'messages.error.selectAtLeastOneProfile': 'Veuillez sélectionner au moins un profil',
  'messages.error.structuralExtractionFailed': 'Erreur d\'extraction : {message}',
  'messages.error.extractionFailedWithName': 'Échec de l\'extraction pour {fileName} : {message}',
  'messages.error.saveProfileFailed': 'Échec de l\'enregistrement du profil de ferme : {message}',
  'messages.error.companyIdentityUpdateFailed': 'Échec de la mise à jour de l\'identité de l\'entreprise',
  'messages.error.companySizeUpdateFailed': 'Échec de la mise à jour de la taille de l\'entreprise',
  'messages.error.sectorActivityUpdateFailed': 'Échec de la mise à jour du secteur et de l\'activité',
  'messages.error.leadershipUpdateFailed': 'Échec de la mise à jour de la direction',
  'messages.error.geographicPresenceUpdateFailed': 'Échec de la mise à jour de la présence géographique',
  'messages.error.aiBusinessIntelligenceUpdateFailed': 'Échec de la mise à jour de l\'intelligence d\'affaires IA',
  'messages.error.documentUploadFailedTitle': 'Échec du téléchargement',
  'messages.error.documentUploadFailedDesc': 'Échec du téléchargement du document. Veuillez réessayer.',

  // Success messages (additional)
  'messages.success.markedInteresting': 'Marqué comme intéressant',
  'messages.success.markedInterestingDesc': 'Nous afficherons plus de subventions similaires',
  'messages.success.markedSaved': 'Marqué comme intéressant',
  'messages.success.markedSavedDesc': 'Enregistré et nous afficherons plus de subventions similaires',
  'messages.success.subsidyHidden': 'Subvention masquée',
  'messages.success.subsidyHiddenDesc': 'Nous n\'afficherons plus de subventions similaires',
  'messages.success.preferenceRemoved': 'Préférence supprimée',
  'messages.success.subsidyAdded': 'Subvention ajoutée à votre suivi',
  'messages.success.subsidyAddedDesc': 'Nous extrayons les détails pour vous...',
  'messages.success.pdfExportedCount': 'PDF exporté avec {count} subvention',
  'messages.success.pdfExportedCountPlural': 'PDF exporté avec {count} subventions',
  'messages.success.appliedFieldsCount': '{count} champs appliqués au profil de ferme',
  'messages.success.reprocessedCount': '{successful}/{processed} documents retraités',
  'messages.success.starredRemoved': 'Retiré des favoris',
  'messages.success.starredAdded': 'Ajouté aux favoris',
  'messages.success.notesUpdated': 'Notes mises à jour',
  'messages.success.remindersEnabled': 'Rappels activés',
  'messages.success.remindersDisabled': 'Rappels désactivés',
  'messages.success.documentQueued': 'Document mis en file d\'attente pour traitement (Tâche : {jobId})',
  'messages.success.documentProcessingComplete': 'Traitement du document terminé avec succès !',
  'messages.success.processingComplete': 'Traitement terminé !',
  'messages.success.documentProcessedSuccess': 'Document traité avec succès ! ({time}ms)',
  'messages.success.needsReviewConfidence': 'Document traité mais nécessite une révision manuelle ({confidence}% confiance)',
  'messages.success.documentProcessedConfidence': 'Document traité avec succès ! ({confidence}% confiance)',
  'messages.success.documentReprocessedPremium': 'Document retraité avec le modèle premium',
  'messages.success.localExtractionComplete': 'Extraction locale terminée',
  'messages.success.localExtractionCompleteDesc': '{count} champs extraits avec {confidence}% de confiance',
  'messages.success.trackingProgress': 'Suivi de la progression de l\'extraction...',
  'messages.success.hybridExtractionSuccess': 'Document traité avec extraction hybride (règles + IA)',
  'messages.success.aiExtractionSuccess': 'Document traité avec extraction IA',
  'messages.success.ruleBasedExtractionSuccess': 'Document traité avec extraction basée sur règles',
  'messages.success.subsidyAssignedSingle': 'Subvention assignée au profil',
  'messages.success.subsidyAssignedMultiple': 'Subvention assignée à {count} profils',
  'messages.success.assignmentRemoved': 'Assignment supprimée',
  'messages.success.structuralExtractionComplete': 'Extraction structurelle terminée avec succès',
  'messages.success.highConfidenceApplied': 'Données haute confiance de {fileName} appliquées automatiquement',
  'messages.success.extractionCompletedReview': 'Extraction terminée pour {fileName}. Vérifiez et appliquez les modifications manuellement.',
  'messages.success.profileUpdated': 'Profil de ferme mis à jour avec succès',
  'messages.success.companyIdentityUpdated': 'Identité de l\'entreprise mise à jour avec succès',
  'messages.success.companySizeUpdated': 'Taille de l\'entreprise mise à jour avec succès',
  'messages.success.sectorActivityUpdated': 'Secteur et activité mis à jour avec succès',
  'messages.success.leadershipUpdated': 'Direction mise à jour avec succès',
  'messages.success.geographicPresenceUpdated': 'Présence géographique mise à jour avec succès',
  'messages.success.aiBusinessIntelligenceUpdated': 'Intelligence d\'affaires IA mise à jour avec succès',
  'messages.success.documentUploadedTitle': 'Document téléchargé avec succès',
  'messages.success.documentUploadedDesc': '{documentName} a été ajouté à votre demande.',

  // Warning messages
  'messages.warning.lowConfidenceExtraction': 'Extraction locale à faible confiance',
  'messages.warning.lowConfidenceExtractionDesc': 'Confiance : {confidence}%. Basculement recommandé.',

  // Info messages (additional)
  'messages.info.trackingProgress': 'Suivi de la progression de l\'extraction...',

  // Confirmation messages
  'messages.confirm.deleteCategory': 'Supprimer la catégorie "{name}" ?',
  'messages.confirm.delete': 'Êtes-vous sûr de vouloir supprimer cet élément ?',
  'messages.confirm.deleteItem': 'Supprimer {itemName} ?',
  'messages.confirm.deleteItemDescription': 'Cette action est irréversible. L\'{itemName} sera définitivement supprimé.',

  // Info messages
  'messages.info.checkResults': 'Vérifiez les résultats ci-dessous',
  'messages.info.profileReady': 'Votre nouveau profil de candidature est prêt à être utilisé',
  'messages.info.descriptionMessage': 'Description message',
} as const;
